import { AppState } from 'state/store';
import { Asset } from 'state/assets/AssetTypes';

export const selectWaveforms = (state: AppState): Asset[] | null => {
   return state.currentAssets.waveforms;
};

export const selectFilteredWaveforms = (state: AppState): Asset[] | null => {
   return state.currentAssets.filteredWaveforms;
};

export const selectSensations = (state: AppState): Asset[] | null => {
   return state.currentAssets.sensations;
};

export const selectFilteredSensations = (state: AppState): Asset[] | null => {
   return state.currentAssets.filteredSensations;
};

export const selectSelectedAsset = (state: AppState): Asset | null => {
   return state.currentAssets.selectedAsset;
};
